import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a06690a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "dashboard-inner" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "new-applied-job-area"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Shortlisted Applications List:", -1))
const _hoisted_10 = { class: "table-wrapper2" }
const _hoisted_11 = { class: "eg-table table category-table mb-0" }
const _hoisted_12 = { "data-label": "Candidate Image" }
const _hoisted_13 = { class: "employee-info" }
const _hoisted_14 = { class: "employee-img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}
const _hoisted_17 = { "data-label": "Candidate Name" }
const _hoisted_18 = { class: "employee-info" }
const _hoisted_19 = { class: "employee-content" }
const _hoisted_20 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModal"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Applied On:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_23 = { "data-label": "Career Summary" }
const _hoisted_24 = { class: "carrer-summary" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createTextVNode("Colliegate Ltd "),
  /*#__PURE__*/_createElementVNode("span", null, "(Teaching Assistant)")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Experience:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salary:", -1))
const _hoisted_28 = { "data-label": "Actions" }
const _hoisted_29 = { class: "action-btn-group" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "review"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 1,
  class: "new-applied-job-area"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Rejected Applications List:", -1))
const _hoisted_41 = { class: "table-wrapper2" }
const _hoisted_42 = { class: "eg-table table category-table mb-0" }
const _hoisted_43 = { "data-label": "Candidate Image" }
const _hoisted_44 = { class: "employee-info" }
const _hoisted_45 = { class: "employee-img" }
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  key: 1,
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}
const _hoisted_48 = { "data-label": "Candidate Name" }
const _hoisted_49 = { class: "employee-info" }
const _hoisted_50 = { class: "employee-content" }
const _hoisted_51 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModal"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Applied On:", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_54 = { "data-label": "Career Summary" }
const _hoisted_55 = { class: "carrer-summary" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createTextVNode("Colliegate Ltd "),
  /*#__PURE__*/_createElementVNode("span", null, "(Teaching Assistant)")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Experience:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salary:", -1))
const _hoisted_59 = { "data-label": "Actions" }
const _hoisted_60 = { class: "action-btn-group" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 1,
  class: "review"
}
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_company_menu),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                type: "hidden",
                value: this.applications
              }, null, 8, _hoisted_6),
              _createVNode(_component_TabMenu, {
                model: _ctx.items,
                onTabChange: _ctx.onTabChange
              }, {
                item: _withCtx(({ item, props }) => [
                  _withDirectives((_openBlock(), _createElementBlock("a", _mergeProps(props.value, { class: "me-3" }), [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1)
                  ], 16)), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              }, 8, ["model", "onTabChange"]),
              (_ctx.activeItem === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("table", _hoisted_11, [
                        _createElementVNode("tbody", null, [
                          (_ctx.shortlistedApplications.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.shortlistedApplications, (application) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: application.id
                                }, [
                                  _createElementVNode("td", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_component_router_link, {
                                          to: '/job-seeker/' + application.user.id
                                        }, {
                                          default: _withCtx(() => [
                                            (application.user?.photo !== null)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: application.user?.photo,
                                                  alt: ""
                                                }, null, 8, _hoisted_15))
                                              : (_openBlock(), _createElementBlock("img", _hoisted_16))
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createTextVNode(_toDisplayString(application.user_name) + " ", 1),
                                        _createElementVNode("button", _hoisted_20, _toDisplayString(application.job?.job_title), 1),
                                        _createElementVNode("p", null, [
                                          _createElementVNode("span", null, "Total reviews: (" + _toDisplayString(application.user.reviews.length) + ")", 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_21,
                                          _createTextVNode(" " + _toDisplayString(application.applied_on), 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_22,
                                          _createTextVNode(" " + _toDisplayString(application.status_name), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                      _hoisted_25,
                                      _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, [
                                          _hoisted_26,
                                          _createTextVNode(" " + _toDisplayString(application.experience) + " Years", 1)
                                        ]),
                                        _createElementVNode("li", null, [
                                          _hoisted_27,
                                          _createTextVNode(" " + _toDisplayString(application.job?.currency) + " " + _toDisplayString(application.salary) + " / " + _toDisplayString(application.job?.payment_mode), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("ul", null, [
                                        (this.permission !== null)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                              (!application.isLoading && (this.permission?.cv_credit > 0))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "review",
                                                    onClick: ($event: any) => (_ctx.downloadCv(application))
                                                  }, " Download CV ", 8, _hoisted_31))
                                                : _createCommentVNode("", true),
                                              (application.isLoading && (this.permission?.cv_credit > 0))
                                                ? (_openBlock(), _createElementBlock("button", _hoisted_32, " Downloading... "))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (application.status_name != 'Shortlisted')
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                              (!application.editClicked)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.updateCandidateApplication('shortlist', application))
                                                  }, " Shortlist", 8, _hoisted_34))
                                                : (_openBlock(), _createElementBlock("button", _hoisted_35, "processing..."))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (application.status_name != 'Rejected')
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                              (!application.editClicked)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.updateCandidateApplication('reject', application)),
                                                    class: "reject"
                                                  }, " Reject", 8, _hoisted_37))
                                                : (_openBlock(), _createElementBlock("button", _hoisted_38, "processing..."))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeItem === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("table", _hoisted_42, [
                        _createElementVNode("tbody", null, [
                          (this.rejectedApplications.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.rejectedApplications, (application) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: application.id
                                }, [
                                  _createElementVNode("td", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createVNode(_component_router_link, {
                                          to: '/job-seeker/' + application.user.id
                                        }, {
                                          default: _withCtx(() => [
                                            (application.user?.photo !== null)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: application.user?.photo,
                                                  alt: ""
                                                }, null, 8, _hoisted_46))
                                              : (_openBlock(), _createElementBlock("img", _hoisted_47))
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _createTextVNode(_toDisplayString(application.user_name) + " ", 1),
                                        _createElementVNode("button", _hoisted_51, _toDisplayString(application.job?.job_title), 1),
                                        _createElementVNode("p", null, [
                                          _createElementVNode("span", null, "Total reviews: (" + _toDisplayString(application.user.reviews.length) + ")", 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_52,
                                          _createTextVNode(" " + _toDisplayString(application.applied_on), 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_53,
                                          _createTextVNode(" " + _toDisplayString(application.status_name), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _hoisted_56,
                                      _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, [
                                          _hoisted_57,
                                          _createTextVNode(" " + _toDisplayString(application.experience) + " Years", 1)
                                        ]),
                                        _createElementVNode("li", null, [
                                          _hoisted_58,
                                          _createTextVNode(" " + _toDisplayString(application.job?.currency) + " " + _toDisplayString(application.salary) + " / " + _toDisplayString(application.job?.payment_mode), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("ul", null, [
                                        (this.permission !== null)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
                                              (!application.isLoading && (this.permission?.cv_credit > 0))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "review",
                                                    onClick: ($event: any) => (_ctx.downloadCv(application))
                                                  }, " Download CV ", 8, _hoisted_62))
                                                : _createCommentVNode("", true),
                                              (application.isLoading && (this.permission?.cv_credit > 0))
                                                ? (_openBlock(), _createElementBlock("button", _hoisted_63, " Downloading... "))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (application.status_name != 'Shortlisted')
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_64, [
                                              (!application.editClicked)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.updateCandidateApplication('shortlist', application))
                                                  }, " Shortlist ", 8, _hoisted_65))
                                                : (_openBlock(), _createElementBlock("button", _hoisted_66, "processing..."))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (application.status_name != 'Rejected')
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                              (!application.editClicked)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.updateCandidateApplication('reject', application)),
                                                    class: "reject"
                                                  }, " Rejected ", 8, _hoisted_68))
                                                : (_openBlock(), _createElementBlock("button", _hoisted_69, "processing..."))
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("button", {
                                            onClick: ($event: any) => (_ctx.deleteCandidateApplication(application.id)),
                                            class: "reject"
                                          }, " Delete", 8, _hoisted_70)
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}